import { ComponentProps, forwardRef } from 'react';
import { motion } from 'motion/react';

import { cn, easeOutSmooth } from '@components/primitives';

import css from './styles.module.css';

export const Separator = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof motion.svg> & { className?: string }
>(function Separator({ className, ...props }, ref) {
  return (
    <motion.svg
      ref={ref}
      className={cn(css.separator, className)}
      viewBox="0 0 7 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, ease: easeOutSmooth }}
      {...props}
    >
      <path d="M4 0L1 17" stroke="currentColor" strokeWidth={1} />
    </motion.svg>
  );
});
